import { render, staticRenderFns } from "./BusTypeIndex.vue?vue&type=template&id=7f7328d2"
import script from "./bus_type_index.js?vue&type=script&lang=js&external"
export * from "./bus_type_index.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports